export interface BBSPost {
  id: number;
  title: string;
  author: string;
  avatar: string;
  date: string;
  category: string;
  views: number;
  replies: number;
  likes: number;
  isPinned?: boolean;
  isHot?: boolean;
  lastReply: string;
  preview: string;
  replies_data: {
    author: string;
    avatar: string;
    date: string;
    content: string;
    likes: number;
  }[];
}

export const bbsPosts: BBSPost[] = [
  {
    id: 1,
    title: '【置顶】元界星图BBS使用指南与社区公约',
    author: '清鉴元衡',
    avatar: 'https://public.readdy.ai/ai/img_res/f9f99287dbef5ab7dc3c6cdf7955625a.jpg',
    date: '2026-03-01',
    category: '公告',
    views: 28600,
    replies: 156,
    likes: 892,
    isPinned: true,
    lastReply: '2026-04-01',
    preview: '欢迎来到元界星图BBS！这里是全球元宇宙爱好者、从业者、研究者的交流家园。请遵守社区公约，共同维护良好的讨论氛围。',
    replies_data: [],
  },
  {
    id: 2,
    title: '脑机接口真的能在2028年商用吗？Neuralink的进展让我既兴奋又担忧',
    author: '神经漫游者',
    avatar: 'https://readdy.ai/api/search-image?query=young%20tech%20enthusiast%20portrait%20dark%20background%20neon%20glow&width=80&height=80&seq=bbs-user-002&orientation=squarish',
    date: '2026-04-01',
    category: '脑机接口',
    views: 15420,
    replies: 89,
    likes: 456,
    isHot: true,
    lastReply: '2026-04-02',
    preview: '最近Neuralink完成了第100例人体植入，数据看起来很惊人。但我有几个问题想和大家讨论：1. 非侵入式BCI的精度真的能达到实用级别吗？2. 意念控制元宇宙的延迟问题如何解决？',
    replies_data: [
      {
        author: '量子观察员',
        avatar: 'https://readdy.ai/api/search-image?query=scientist%20portrait%20dark%20background%20blue%20glow&width=80&height=80&seq=bbs-reply-001&orientation=squarish',
        date: '2026-04-01',
        content: '从技术路线来看，非侵入式BCI的精度提升速度确实超出预期。关键突破在于信号处理算法，而不是传感器本身。我认为2028年消费级产品是可能的，但初期功能会比较有限，主要用于简单的意念输入。',
        likes: 234,
      },
      {
        author: '元宇宙建筑师',
        avatar: 'https://readdy.ai/api/search-image?query=architect%20designer%20portrait%20dark%20background%20warm%20light&width=80&height=80&seq=bbs-reply-002&orientation=squarish',
        date: '2026-04-01',
        content: '延迟问题是关键。6G网络的0.1ms延迟加上BCI信号处理的50ms，总延迟约50ms，这已经低于人类神经系统的感知阈值（约100ms）。所以理论上是可行的。',
        likes: 189,
      },
      {
        author: '数字哲学家',
        avatar: 'https://readdy.ai/api/search-image?query=philosopher%20thinker%20portrait%20dark%20background%20mysterious&width=80&height=80&seq=bbs-reply-003&orientation=squarish',
        date: '2026-04-02',
        content: '技术可行性不是最大的问题，伦理和隐私才是。当你的思维可以被读取，谁来保证你的意识安全？这需要在技术商用之前建立完整的法律框架。',
        likes: 312,
      },
    ],
  },
  {
    id: 3,
    title: '量子计算机真的能在2030年前解决元宇宙的算力瓶颈吗？深度分析',
    author: '量子观察员',
    avatar: 'https://readdy.ai/api/search-image?query=scientist%20portrait%20dark%20background%20blue%20glow&width=80&height=80&seq=bbs-user-003&orientation=squarish',
    date: '2026-03-28',
    category: '量子计算',
    views: 12380,
    replies: 67,
    likes: 389,
    isHot: true,
    lastReply: '2026-04-01',
    preview: '谷歌Willow-2实现了1000量子比特，IBM也在快速追赶。但量子计算机真的能用于元宇宙物理模拟吗？我做了一些计算，结论有点出乎意料...',
    replies_data: [
      {
        author: '清鉴元衡',
        avatar: 'https://readdy.ai/api/search-image?query=wise%20Chinese%20scholar%20portrait%20ink%20painting%20style%20dark%20background&width=80&height=80&seq=bbs-admin-002&orientation=squarish',
        date: '2026-03-29',
        content: '非常好的分析！我补充一点：量子计算机不会直接替代传统GPU做渲染，而是会在物理模拟、AI推理、密码学等特定领域发挥作用。元宇宙的算力架构将是量子+经典的混合体系。',
        likes: 456,
      },
      {
        author: '芯片猎人',
        avatar: 'https://readdy.ai/api/search-image?query=engineer%20tech%20person%20portrait%20dark%20background%20circuit%20board&width=80&height=80&seq=bbs-reply-004&orientation=squarish',
        date: '2026-03-30',
        content: '英伟达的Blackwell Ultra已经把传统GPU的AI推理性能提升了10倍，量子计算机的商用化可能比我们预期的更晚。2030年前实现量子优势突破是可能的，但大规模商用可能要到2035年。',
        likes: 234,
      },
    ],
  },
  {
    id: 4,
    title: '我在元宇宙里举办了婚礼，分享一下真实体验和感受',
    author: '虚实之间',
    avatar: 'https://readdy.ai/api/search-image?query=young%20couple%20portrait%20dark%20background%20soft%20light%20romantic&width=80&height=80&seq=bbs-user-004&orientation=squarish',
    date: '2026-03-25',
    category: '生活体验',
    views: 45600,
    replies: 234,
    likes: 1890,
    isHot: true,
    lastReply: '2026-04-02',
    preview: '上个月我和我的伴侣在Horizon Worlds举办了元宇宙婚礼，邀请了来自12个国家的亲友参加。整个过程既感动又奇妙，想和大家分享这段特别的经历...',
    replies_data: [
      {
        author: '数字浪漫主义',
        avatar: 'https://readdy.ai/api/search-image?query=romantic%20person%20portrait%20dark%20background%20stars&width=80&height=80&seq=bbs-reply-005&orientation=squarish',
        date: '2026-03-25',
        content: '太感动了！元宇宙婚礼最大的优势就是打破了地理限制，让所有重要的人都能参与。请问你们用的是什么XR设备？画质和沉浸感如何？',
        likes: 567,
      },
      {
        author: '传统守护者',
        avatar: 'https://readdy.ai/api/search-image?query=traditional%20person%20portrait%20dark%20background%20warm&width=80&height=80&seq=bbs-reply-006&orientation=squarish',
        date: '2026-03-26',
        content: '我理解元宇宙婚礼的便利性，但总觉得少了些什么。婚礼的意义在于两个人在众人见证下的承诺，这种仪式感在虚拟空间中能完全复现吗？',
        likes: 234,
      },
      {
        author: '虚实之间',
        avatar: 'https://readdy.ai/api/search-image?query=young%20couple%20portrait%20dark%20background%20soft%20light%20romantic&width=80&height=80&seq=bbs-user-004&orientation=squarish',
        date: '2026-03-26',
        content: '回复传统守护者：我们同时也在现实中举办了小型仪式，元宇宙婚礼是补充而非替代。当我看到来自澳大利亚的外婆、美国的大学同学都出现在虚拟婚礼现场时，那种感动是真实的。',
        likes: 789,
      },
    ],
  },
  {
    id: 5,
    title: 'Web5.0去中心化身份：我尝试了一个月，说说真实感受',
    author: 'DID先行者',
    avatar: 'https://readdy.ai/api/search-image?query=tech%20pioneer%20person%20portrait%20dark%20background%20blockchain%20nodes&width=80&height=80&seq=bbs-user-005&orientation=squarish',
    date: '2026-03-20',
    category: 'Web5.0',
    views: 8920,
    replies: 45,
    likes: 267,
    lastReply: '2026-03-31',
    preview: '用了一个月的去中心化数字身份（DID），体验了Web5.0的早期生态。优点和痛点都很明显，分享给大家参考...',
    replies_data: [
      {
        author: '区块链信徒',
        avatar: 'https://readdy.ai/api/search-image?query=blockchain%20developer%20portrait%20dark%20background%20crypto&width=80&height=80&seq=bbs-reply-007&orientation=squarish',
        date: '2026-03-21',
        content: 'DID的核心价值在于数据主权，但目前的用户体验确实还不够友好。我认为Web5.0的大规模普及需要等到更好的钱包和身份管理工具出现。',
        likes: 123,
      },
    ],
  },
  {
    id: 6,
    title: '2050年人类会是什么样子？我的大胆预测（附详细推演）',
    author: '未来考古学家',
    avatar: 'https://readdy.ai/api/search-image?query=futurist%20thinker%20portrait%20dark%20background%20time%20portal&width=80&height=80&seq=bbs-user-006&orientation=squarish',
    date: '2026-03-15',
    category: '未来展望',
    views: 32400,
    replies: 178,
    likes: 1234,
    isHot: true,
    lastReply: '2026-04-01',
    preview: '基于当前技术发展速度，我做了一个关于2050年人类生活的详细推演。结论可能会让你感到震惊，但每一个预测都有技术依据...',
    replies_data: [
      {
        author: '清鉴元衡',
        avatar: 'https://readdy.ai/api/search-image?query=wise%20Chinese%20scholar%20portrait%20ink%20painting%20style%20dark%20background&width=80&height=80&seq=bbs-admin-003&orientation=squarish',
        date: '2026-03-16',
        content: '非常有深度的推演！我特别认同关于"工作消失"的预测。当AI和机器人承担了所有生产性工作，人类将面临一个根本性的问题：我们存在的意义是什么？这将是2040-2050年最重要的哲学命题。',
        likes: 678,
      },
      {
        author: '悲观主义者',
        avatar: 'https://readdy.ai/api/search-image?query=skeptic%20person%20portrait%20dark%20background%20shadow&width=80&height=80&seq=bbs-reply-008&orientation=squarish',
        date: '2026-03-17',
        content: '我对这些预测持保留态度。技术发展从来不是线性的，总会遇到意想不到的障碍。而且，技术进步不等于人类幸福感的提升，这是历史一再证明的。',
        likes: 345,
      },
    ],
  },
  {
    id: 7,
    title: '6G商用一年了，作为深圳用户说说真实体验',
    author: '深圳数字人',
    avatar: 'https://readdy.ai/api/search-image?query=Shenzhen%20tech%20person%20portrait%20dark%20background%20city%20lights&width=80&height=80&seq=bbs-user-007&orientation=squarish',
    date: '2026-03-10',
    category: '6G体验',
    views: 19800,
    replies: 123,
    likes: 678,
    lastReply: '2026-03-30',
    preview: '深圳6G商用已经一年了，作为第一批用户，我来说说真实的使用体验。速度确实快，但有些地方和宣传有出入...',
    replies_data: [
      {
        author: '上海数字人',
        avatar: 'https://readdy.ai/api/search-image?query=Shanghai%20tech%20person%20portrait%20dark%20background&width=80&height=80&seq=bbs-reply-009&orientation=squarish',
        date: '2026-03-11',
        content: '上海的6G试点区域体验也差不多，室内覆盖还有待改善。但用6G看元宇宙直播的体验确实是质的飞跃，完全没有卡顿感。',
        likes: 234,
      },
    ],
  },
  {
    id: 8,
    title: '元宇宙里的社交关系：虚拟友谊和现实友谊有什么不同？',
    author: '社交实验家',
    avatar: 'https://readdy.ai/api/search-image?query=social%20researcher%20person%20portrait%20dark%20background%20network%20nodes&width=80&height=80&seq=bbs-user-008&orientation=squarish',
    date: '2026-03-05',
    category: '社交',
    views: 24500,
    replies: 156,
    likes: 890,
    lastReply: '2026-03-28',
    preview: '我在元宇宙里交了几个"朋友"，有些从未见过面，但感情比某些现实朋友还深。这让我开始思考：虚拟社交关系的本质是什么？',
    replies_data: [
      {
        author: '心理学观察者',
        avatar: 'https://readdy.ai/api/search-image?query=psychologist%20person%20portrait%20dark%20background%20mind&width=80&height=80&seq=bbs-reply-010&orientation=squarish',
        date: '2026-03-06',
        content: '从心理学角度看，情感连接的深度与媒介无关，而与互动的质量和频率有关。元宇宙提供了更丰富的互动维度（表情、动作、共同体验），理论上可以建立比文字社交更深的情感连接。',
        likes: 456,
      },
    ],
  },
];
